import axios, { AxiosInstance } from "axios";
import AuthService from "@/services/auth.service";

export default abstract class ApiService {
    protected axiosInstance: AxiosInstance;

    protected constructor() {
        this.axiosInstance = axios.create();

        this.axiosInstance.interceptors.request.use(async (config) => {
            const token = await AuthService.getToken();

            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${token}`
            };

            return config;
        });
    }
}
